"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectDestructuringEmpty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectDestructuringEmpty"));

var _react = _interopRequireDefault(require("react"));

var _Item = _interopRequireDefault(require("./Item"));

var _Card = _interopRequireDefault(require("./Card"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function Preloader(_ref) {
  (0, _objectDestructuringEmpty2["default"])(_ref);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultModule["default"]['wrapper']
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultModule["default"]['content']
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultModule["default"]['header']
  }, /*#__PURE__*/_react["default"].createElement(_Item["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultModule["default"]['cards']
  }, /*#__PURE__*/_react["default"].createElement(_Card["default"], null), /*#__PURE__*/_react["default"].createElement(_Card["default"], null), /*#__PURE__*/_react["default"].createElement(_Card["default"], null))));
}

var _default = Preloader;
exports["default"] = _default;